import { useRef } from 'react'
import PropTypes from 'prop-types'

import { Body, Container, Icon, Input } from './styles'

const Checkbox = ({
  checked = false,
  disabled = false,
  hasError = false,
  name = '',
  onChange = () => {},
  'aria-label': ariaLabel,
  ...restProps
}) => {
  const inputRef = useRef()

  const focusInput = () => inputRef.current.focus()

  const wrappedOnChange = (event) => {
    onChange(event.currentTarget.checked)
  }

  return (
    <Container {...restProps}>
      <Input
        name={name}
        value={checked}
        checked={checked}
        disabled={disabled}
        onChange={wrappedOnChange}
        onClick={focusInput}
        aria-label={ariaLabel}
        ref={inputRef}
      />
      <Body hasError={hasError}>
        <Icon />
      </Body>
    </Container>
  )
}

Checkbox.propTypes = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  'aria-label': PropTypes.string
}

export default Checkbox
